import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getExportConfig } from 'api/Export';

const ONE_HOUR = 1000 * 60 * 60;

export const useExportConfig = (options = {}) => {
  const navigate = useNavigate();

  return useQuery(['export-config'], () => getExportConfig(navigate, {}), {
    staleTime: ONE_HOUR,
    cacheTime: ONE_HOUR,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};
